module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit-org"
  }, [_c('ep-title', {
    attrs: {
      "title": "修改资料"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "org-form"
  }, [(_vm.orgState == 0) ? _c('Entform', {
    ref: "modifyenff",
    attrs: {
      "isUpdata": _vm.isUpdata
    },
    on: {
      "change": _vm.onSubmitenf
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orgState == 1) ? _c('Govform', {
    ref: "modifygov",
    attrs: {
      "isUpdata": _vm.isUpdata
    },
    on: {
      "change": _vm.onSubmitgov
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orgState == 2) ? _c('Parkform', {
    ref: "modifypark",
    attrs: {
      "isUpdata": _vm.isUpdata
    },
    on: {
      "change": _vm.onSubmitpark
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orgState == 3) ? _c('Wtfrom', {
    ref: "modifywtf",
    attrs: {
      "isUpdata": _vm.isUpdata
    },
    on: {
      "change": _vm.onSubmitwtf
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orgState == 4) ? _c('Otherform', {
    ref: "modifyother",
    attrs: {
      "isUpdata": _vm.isUpdata
    },
    on: {
      "change": _vm.onSubmitother
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "org-control"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeconfirm
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fc33f9a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/unitmanage/editunit.vue
// module id = 1258
// module chunks = 2